import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
DashboardController.$inject = ["API_URL", "$http", "$q", "$routeParams", "$rootScope", "$timeout"];
angular.module('userApp').controller('DashboardController', DashboardController);

function DashboardController(API_URL, $http, $q, $routeParams, $rootScope, $timeout) {
  if (!$rootScope.userInfo) return;
  var dash = this,
      throbber = $rootScope.throbber;
  dash.isOwner = $rootScope.userInfo.roles.find(function (role) {
    return role.type === 'OWNER';
  });
  dash.surveyEmotion = '';
  dash.dashboardDisplay = 'CLASS';

  dash.submitSurvey = function () {
    dash.surveyMessage = 'Please wait...';
    $http.post(API_URL + '/api/v1/surveys', {
      survey: {
        surveyid: $rootScope.userSurvey._id,
        answer: dash.surveyEmotion
      }
    }).then(function (_ref) {
      var response = _ref.response;
      console.log(response);
      dash.surveyMessage = 'Thank you so much for your feedback. Your answer helps us to create a better service for you.';
      $timeout(function () {
        dash.surveyMessage = '';
        $rootScope.userSurvey = null;
      }, 4000);
    });
  };

  dash.getCustomers = function (params) {
    var params = params || {
      getappointments: true
    };
    dash.paginationObject = {
      count: 0,
      page: 0
    };
    params.page = params.page || 0;
    params.perpage = params.perpage || 10;
    throbber.show();
    var deferred = $q.defer();
    $http.get(API_URL + '/api/v1/customer', {
      params: params
    }).then(function (reply) {
      throbber.hide();
      var response = reply.data;

      if (!response.success) {
        throbber.showError(response.msg);
        deferred.resolve(dash.paginationObject);
        return;
      }

      dash.customers = response.customers;
      dash.paginationObject.count = parseInt(response.count);
      dash.paginationObject.page = parseInt(response.page);
      deferred.resolve(dash.paginationObject);
    }).catch(function (error) {
      console.error(error.message);
      throbber.showError("Sorry but an error occurred: ".concat(error.message));
    });
    return deferred.promise;
  }; // See if the user has any shifts, show helpful message if they don't


  $http.get(API_URL + '/api/v1/shift').then(function (reply) {
    dash.shifts = reply.data.shifts;
  });

  function getUserSettings() {
    var userID = $rootScope.userInfo._id;
    $http.get("".concat(API_URL, "/api/v1/user/settings/").concat(userID)).then(function (_ref2) {
      var data = _ref2.data;
      dash.dashboardDisplay = data.settings.dashboarddisplay || 'CLASS';
    }).catch(function (err) {
      // Don't do anything at this stage.
      console.error(err.message);
    });
  }

  function getOrgSettings() {
    // These calls are to determine charging related settings
    Promise.all([$http.get("".concat(API_URL, "/api/v1/settings/organisation")), $http.get(API_URL + '/api/v1/settings/charging', {
      withCredentials: true
    })]).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          orgSettings = _ref4[0],
          chargingSettings = _ref4[1];

      var org = orgSettings.data.organisation;
      var charging = chargingSettings.data.settings;
      dash.stripeConnected = charging.stripeAuthorised; // Just doing this to determine whether the org has migrated their connected account settings or not.

      dash.connectAccountsMigrated = !!org.connectTransferred;
      dash.showConnectMigration = !!org.showConnectMigration;
      console.log("Connect accounts migrated: ".concat(dash.connectAccountsMigrated));
      console.log("Show connect migration: ".concat(dash.showConnectMigration));
    }).catch(function (err) {
      // Don't do anything at this stage.
      console.error(err.message);
    });
  }

  getUserSettings();
  getOrgSettings();

  dash.updateView = function (viewType) {
    var userID = $rootScope.userInfo._id;
    $http.put("".concat(API_URL, "/api/v1/user/settings/").concat(userID), {
      dashboardDisplay: viewType
    }).then(function (_ref5) {
      var data = _ref5.data;
      dash.dashboardDisplay = data.settings.dashboarddisplay;
      dash.showConnectMigration = !!data.settings.showConnectMigration;
    }).catch(function (err) {
      // Don't do anything at this stage.
      console.error(err.message);
    });
  }; // Latest posts from forum


  $http.get("".concat(API_URL, "/api/v1/forumtopics")).then(function (_ref6) {
    var data = _ref6.data;
    if (data.success) dash.forumTopics = data.latest_posts;
  });

  var checkInvoices =
  /*#__PURE__*/
  function () {
    var _ref7 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _ref8, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return $http.get(API_URL + '/api/v1/invoices/unpaid-invoices');

            case 3:
              _ref8 = _context.sent;
              data = _ref8.data;

              if (data.outstandingInvoices && data.outstandingInvoices.length) {
                $rootScope.unpaidInvoices = data.outstandingInvoices;
                $rootScope.safeApply();
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error("Error retrieving outstandingInvoices: ".concat(_context.t0.message));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 8]]);
    }));

    return function checkInvoices() {
      return _ref7.apply(this, arguments);
    };
  }();

  dash.isOwner && checkInvoices();

  if ($routeParams.dotour) {
    $timeout(function () {
      smooth.dashboardTour.init();
      smooth.dashboardTour.start(true);
    }, 0);
  }
}